export default function (totalCharge, quantity, transactionId) {
  fbq("track", "Purchase", {
    value: totalCharge,
    currency: "USD",
    order_id: transactionId,
    content_ids: transactionId,
    content_type: "product",
  });

  // Track purchase event for Reddit pixel if available
  if (typeof window !== "undefined" && typeof window.rdt === "function") {
    window.rdt("track", "Purchase", {
      value: totalCharge,
      currency: "USD",
      transactionId: transactionId,
    });
  }
}
